import {
  SharedWorkerPonyfill
} from "./chunk-TTLQG7LX.js";
import {
  SharedWorkerSupported
} from "./chunk-R6SF5J3G.js";

// src/polyfill.ts
var SharedWorkerPolyfill = class extends SharedWorkerPonyfill {
  constructor(url, opts) {
    let worker;
    if (SharedWorkerSupported) {
      worker = new SharedWorker(url, opts);
    } else {
      worker = new Worker(url, opts);
    }
    super(worker);
  }
};
var polyfill_default = SharedWorkerPolyfill;

export {
  SharedWorkerPolyfill,
  polyfill_default
};
//# sourceMappingURL=chunk-SBVDHLJL.js.map